import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        path: ':id',
        lazy: async () => {
            const { Layout } = await import('@@routes/maintenancenotes');

            return { Component: Layout };
        },
    },
];
